import React, { useEffect, useState, useContext, useRef } from "react";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { StyledTablePmePrograma } from "../../../styled-components/StyledTablePmePrograma.style";
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import { MobileContext } from "../../../contexts/MobileContext";
import { StldRow } from "../../../styled-components/StldRow.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { DynamicInput } from "../../../components/DynamicInput";

import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-datepicker';

import api from '../../../services/api';
import Flex from '@react-css/flex';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";

export const TopFeeMakerResultPme = () => {
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const history = useHistory();
    const { idPrograma } = useParams(); 

    const [isList, setIsList] = useState(true);    
    const [isLoading, setIsLoading] = useState(true);   
    
    const [programaData, setProgramaData] = useState(null);
    const [listaProgramas, setListaProgramas] = useState(null); 
    const [listaUsuariosData, setListaUsuariosData] = useState(null);
    const [multiplicadores, setMultiplicadores] = useState([]);

    const [programaDataInicio, setProgramaDataInicio] = useState(null);
    const [programaDataFim, setProgramaDataFim] = useState(null);

    const [mesesDisponiveis, setMesesDisponiveis] = useState([]);
    const [mesSelecionado, setMesSelecionado] = useState(12);

    const meses = [
        { nome: "JAN", numero: 0 },
        { nome: "FEV", numero: 1 },
        { nome: "MAR", numero: 2 },
        { nome: "ABR", numero: 3 },
        { nome: "MAI", numero: 4 },
        { nome: "JUN", numero: 5 },
        { nome: "JUL", numero: 6 },
        { nome: "AGO", numero: 7 },
        { nome: "SET", numero: 8 },
        { nome: "OUT", numero: 9 },
        { nome: "NOV", numero: 10 },
        { nome: "DEZ", numero: 11 }
    ];

    const handleStartDateChange = (date) => {
        setProgramaDataInicio(date);
    };

    const handleEndDateChange = (date) => {
        setProgramaDataFim(date);
    };

    const getPrograma = async(id) => {
        const response = await api.get(`PmePrograma/${id}`);
        const programa = response.data.data;
        setProgramaData(programa);       

        const dataInicio = new Date(programa.dataInicio);
        const dataFinal = new Date(programa.dataFim);

        setProgramaDataInicio(dataInicio.toISOString().slice(0, 19).replace("T", " "));
        setProgramaDataFim(dataFinal.toISOString().slice(0, 19).replace("T", " "));         
    };

    const getListaProgramas = async() => {
        let params = {};
        const response = await api.get(`PmePrograma`, { params });
        console.log('response', response.data);
        setListaProgramas(response.data);
    };

    const getProfissionaisPrograma = async(id, dataFinalPrograma = null) => {
        const dtInicio = new Date(programaDataInicio);
        const dtFinal = new Date(dataFinalPrograma);

        //console.log('dtInicio', dtInicio);
        //console.log('dtFinal', dtFinal);
        const response = await api.get(`PmeProfissionalPME/profissionais/resultados/${id}`);
        setListaUsuariosData(response.data);
    };    

    const calcularPorcentagemTempoXAdmissao = (dataAdmissao) => {
        if (!dataAdmissao) return '0.00';
        const admissao = new Date(dataAdmissao);
        const inicioPeriodo = new Date(programaDataInicio);
        const fimPeriodo = new Date(programaDataFim);

        const diasNoMesAdmissao = new Date(admissao.getFullYear(), admissao.getUTCMonth() + 1, 0).getDate();
        const diasTrabalhadosNoMes = diasNoMesAdmissao - admissao.getDate() + 1;
        const porcentagemMesAdmissao = diasTrabalhadosNoMes / diasNoMesAdmissao;

        const mesesRestantes = Math.max(0, fimPeriodo.getMonth() - admissao.getMonth());
        const totalMesesPrograma = (fimPeriodo.getFullYear() - inicioPeriodo.getFullYear()) * 12 + (fimPeriodo.getMonth() - inicioPeriodo.getMonth()) + 1;
        const tempoTrabalhado = (porcentagemMesAdmissao + mesesRestantes) / totalMesesPrograma;

        // console.log("======= TEMPO =======");

        // console.log('diasNoMesAdmissao', diasNoMesAdmissao);
        // console.log('diasTrabalhadosNoMes', diasTrabalhadosNoMes);
        // console.log('porcentagemMesAdmissao', porcentagemMesAdmissao);

        // console.log('mesesRestantes', mesesRestantes);
        // console.log('totalMesesPrograma', totalMesesPrograma);
        // console.log('tempoTrabalhado', tempoTrabalhado);

        // console.log("======= TEMPO =======");

        return ((tempoTrabalhado) * 100);
    };

    const calcularPorcentagemProfissionalFranquia = (idProfissional, dataAdmissao, percFranquia) => {
        //Verificar se aplica ou nao
        let profissional = listaUsuariosData.data.find((usuario) => usuario.idProfissional === idProfissional);
        let resultadoFinal = 1;
        if(profissional.participacaoFranquia) {
            const admissao = new Date(dataAdmissao);
            const inicioPeriodo = new Date(programaDataInicio)
            const fimPeriodo = new Date(programaDataFim);

            const diasNoMesAdmissao = new Date(admissao.getFullYear(), admissao.getUTCMonth() + 1, 0).getDate();
            const diasTrabalhadosNoMes = diasNoMesAdmissao - admissao.getDate() + 1;
            const porcentagemMesAdmissao = diasTrabalhadosNoMes / diasNoMesAdmissao;
            
            const mesesRestantes = Math.max(0, fimPeriodo.getMonth() - admissao.getMonth());
            const totalMesesPrograma = (fimPeriodo.getFullYear() - inicioPeriodo.getFullYear()) * 12 + (fimPeriodo.getMonth() - inicioPeriodo.getMonth()) + 1;
            const tempoTrabalhado = (porcentagemMesAdmissao + mesesRestantes) / totalMesesPrograma;

            const mesesTrabalhados = (fimPeriodo.getFullYear() - inicioPeriodo.getFullYear()) * 12 + (fimPeriodo.getMonth() - inicioPeriodo.getMonth()) + 1;
            const resultado = (porcentagemMesAdmissao + mesesRestantes);

            //Aplicar somente se flag estiver marcada
            const peso1Mes = 0 * Math.min(1, mesesTrabalhados);
            const peso2e3Meses = 0.7 * Math.max(0, Math.min(2, mesesTrabalhados - 1)) / resultado;        
            const pesoRestante = 1 * (resultado - 3) / resultado; 

            resultadoFinal = peso1Mes + peso2e3Meses + pesoRestante;
        }
        
        // console.log("======= FRANQUIA =======");
        // console.log('mesesTrabalhados', mesesTrabalhados);
        // console.log('peso1Mes', peso1Mes);
        // console.log('peso2e3Meses', peso2e3Meses);
        // console.log('pesoRestante', pesoRestante);
        // console.log('resultado', resultado);
        // console.log('resultadoFinal', resultadoFinal);
        // console.log("======= FRANQUIA =======");
    
        return (resultadoFinal * 100);        
    };

    const calcularCalibracaoTotal = (idProfissional, dataAdmissao, percProfissional) => {
        const percentTempo = calcularPorcentagemTempoXAdmissao(dataAdmissao);
        const percentFranquia = calcularPorcentagemProfissionalFranquia(idProfissional, dataAdmissao, 100);
        return (((percentTempo * percentFranquia) / 100) / 100);
    };

    const calcularGatilho = (calibTotal, gatilho) => {
        const result = calibTotal * gatilho;
        return result;
    };

    const calcularYTD = (gatilho) => {
        const date = new Date();
        const result = (gatilho / 12) * date.getUTCMonth();
        return result;
    };

    const calcularYTDPerc = (hfi, proporcional) => {
        const result = (hfi / proporcional) * 100;
        return result;
    };

    const calcularHFMu = (dados) => {
        if (!dados || !Array.isArray(dados) || dados.length === 0) return {};
    
        const resultadosPorArea = {};
    
        dados.forEach((item) => {
            const { idArea, horaFaturada, idProfissional, dataAdmissao, percProfissional } = item;
    
            // Calcular calibracaoTotal para cada profissional
            const calibracao = calcularCalibracaoTotal(idProfissional, dataAdmissao, percProfissional);
    
            if (!resultadosPorArea[idArea]) {
                resultadosPorArea[idArea] = {
                    somaProduto: 0,
                    somaCalibracao: 0,
                };
            }
    
            // Atualizar somaProduto e somaCalibracao
            const hora = parseFloat(horaFaturada) || 0;
            resultadosPorArea[idArea].somaProduto += hora * calibracao;
            resultadosPorArea[idArea].somaCalibracao += calibracao;
        });
    
        const resultadosFinais = {};
        Object.keys(resultadosPorArea).forEach((idArea) => {
            const { somaProduto, somaCalibracao } = resultadosPorArea[idArea];
            resultadosFinais[idArea] = somaCalibracao > 0 ? (somaProduto / somaCalibracao).toFixed(2) : 0;
        });
    
        return resultadosFinais;
    };       

    const calcularHFMg = (dados, calibracaoTotal) => {
        if (!dados || !Array.isArray(dados) || dados.length === 0) return 0;
    
        const somaProduto = dados.reduce((soma, item) => {
            //console.log('==', item.nome, "==");
            //console.log('* horaFaturada', item.horaFaturada);
            //console.log('* calibracaoTotal', calibracaoTotal);

            const horaFaturada = parseFloat(item.horaFaturada) || 0;
            const calibracao = parseFloat(calcularCalibracaoTotal(item.idProfissional, item.dataAdmissao, item.percProfissional)) || 0;
            return soma + horaFaturada * calibracao;
        }, 0);
    
        const somaCalibracao = dados.reduce((soma, item) => {
            const calibracao = parseFloat(calcularCalibracaoTotal(item.idProfissional, item.dataAdmissao, item.percProfissional)) || 0;
            return soma + calibracao;
        }, 0);
    
        //console.log('* somaProduto', somaProduto);
        //console.log('* somaCalibracao', somaCalibracao);

        let tot = somaCalibracao > 0 ? (somaProduto / somaCalibracao).toFixed(2) : 0;
        //console.log('# HMFg', tot);

        //console.log('dados', dados);
        //console.log("----------------")

        return somaCalibracao > 0 ? (somaProduto / somaCalibracao).toFixed(2) : 0;
    };

    const calculaHFIc = (calibracaoFranqProf, calibracaoTempo, horaFaturada) => {
        const fator = (1 + (1 - (calibracaoFranqProf / 100))) / calibracaoTempo;
        const hfic = fator * horaFaturada;

        // console.log('calibracaoFranqProf', calibracaoFranqProf / 100);
        // console.log('calibracaoTempo', calibracaoTempo);
        // console.log('fator', fator);
        // console.log('hfic', hfic);
        // console.log('=-=====');

        return hfic;
    };

    const calculoMeritos = (hfmic, hmfu, hmfg, area) => {
        
        let calcMerito = 0;
        if(area == "Designers") {
            calcMerito = (0.60 * hfmic) + (0.40 * hmfg);
        } else {
            calcMerito = (0.60 * hfmic) + (0.30 * hmfu) + (0.10 * hmfg);
        }
        return calcMerito;
    };

    const getacoes = (idPrograma) => {
        return (
            <div className="text-center">
                <span className="cursor-pointer color-icon-default m-1" onClick={() => setRedirectFormEdit(idPrograma)} title="Editar este programa">
                    <i className="fa fa-eye" aria-hidden="true"></i>
                </span>
            </div>
        );
    };

    const voltar = async () => {
        setIsList(true)
        history.push(`/pme-top-fee-maker`)
    }

    const setRedirectFormEdit = (idPrograma) => {
        history.push(`/pme-top-fee-maker/${idPrograma}`);
    }

    const handleSetDataFim = async (mes) => {
        try {
            setIsLoading(true);
            const dataAtualizada = new Date();
            dataAtualizada.setMonth(mes, 0); // Define o mês e coloca o último dia do mês
            dataAtualizada.setHours(0, 0, 0, 0);

            setProgramaDataFim(dataAtualizada);
            setMesSelecionado(mes);

            if (idPrograma) { 
                await getProfissionaisPrograma(idPrograma, dataAtualizada);
            }
        } catch (err) {
            console.error("Erro na inicialização:", err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const getMultiplicadores = async () => {
        try {
            const response = await api.get(`TabelaMultiplicadores/multiplicador/1/${idPrograma}`);
            //console.log('multiplicadores', response.data.data);
            setMultiplicadores(response.data.data);
        } catch (err) {
            console.error("Erro ao buscar multiplicadores:", err.message);
        }
    };

    const getMultiplicador = (merito, multiplicadores) => {
        if (!multiplicadores || multiplicadores.length === 0) {
            return 0; // Retorna 0 se não houver multiplicadores
        }
    
        // Filtrar os multiplicadores que atendem à condição
        const multiplicadorEncontrado = multiplicadores.find(multi => 
            merito >= multi.de && merito <= multi.ate
        );
    
        return multiplicadorEncontrado ? multiplicadorEncontrado.multiplicador : 0;
    };

    const getMultiplicadorTempo = (calibracaoTotal, multiplicador) => {
        //console.log('calibracaoTotal', calibracaoTotal);
        //console.log('multiplicador', multiplicador);
        //console.log('calculo', (multiplicador * calibracaoTotal));
        return multiplicador * calibracaoTotal;
    }

    const temMaisDeTresAnos = (dataAdmissao) => {
        if (!dataAdmissao) return false; // Caso a data de admissão não seja fornecida
        const dataAtual = new Date();
        const dataAdmissaoDate = new Date(dataAdmissao);
    
        // Calcula a diferença em anos
        const diferencaAnos = dataAtual.getFullYear() - dataAdmissaoDate.getFullYear();
    
        // Verifica se já completou o terceiro aniversário considerando o mês e o dia
        if (
            diferencaAnos > 3 ||
            (diferencaAnos === 3 && 
            (dataAtual.getMonth() > dataAdmissaoDate.getMonth() || 
             (dataAtual.getMonth() === dataAdmissaoDate.getMonth() && dataAtual.getDate() >= dataAdmissaoDate.getDate())))
        ) {
            return true;
        }
    
        return false;
    };

    useEffect(() => {
        const asyncFn = async () => {
            try {
                setIsLoading(true);
                if (idPrograma) {
                    setIsList(false);
                    await getPrograma(idPrograma);              
                    await getProfissionaisPrograma(idPrograma, null); 
                    await getMultiplicadores();
                    
                    const hoje = new Date();
                    const mesCorrente = hoje.getMonth();
                    const mesInicio = programaDataInicio ? new Date(programaDataInicio).getMonth() : 0;

                    const mesesFiltrados = meses.filter(mes => mes.numero <= mesCorrente && mes.numero >= mesInicio);
                    setMesesDisponiveis(mesesFiltrados);
                } else {
                    await getListaProgramas();
                }
                
            } catch (err) {
                console.error("Erro na inicialização:", err.message);
            } finally {
                setIsLoading(false);
            }           
        }
        asyncFn()
    }, [idPrograma, programaDataInicio]);

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">PME - Top Fee Maker</h5>
                        </div>
                        { !isList ? <input type="button" className='default-button ml-3' value='Voltar' onClick={voltar} /> : ''}
                    </div>
                    { !isList ?
                        <div className="card">
                            <div className="row justify-content-left mb-2">
                                {/*<div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12">
                                {mesesDisponiveis.map((mes) => (
                                    <input
                                        key={mes.nome}
                                        type="button"
                                        className={mesSelecionado > (mes.numero) ? "default-button me-1" : "default-button-red me-1"}
                                        value={mes.nome}
                                        onClick={() => handleSetDataFim(mes.numero + 1)} // +1 para setar o último dia corretamente
                                    />
                                ))}
                                </div>
                                 <div className="col-sm-12 col-md-4 col-lg-4 col-xxl-4">
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        locale="pt-BR"
                                        className="input-form"
                                        selected={programaDataInicio}
                                        onChange={handleStartDateChange}
                                        name={'dataInicio'}
                                        placeholderText={'Data Inicial'}
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 col-lg-4 col-xxl-4">
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        locale="pt-BR"
                                        className="input-form"
                                        selected={programaDataFim}
                                        onChange={handleEndDateChange}
                                        name={'dataFim'}
                                        placeholderText={'Data Final'}
                                    />
                                </div> */}
                            </div>
                            {/* <div className="row justify-content-between mb-3">
                                <div className="col-sm-12 col-md-2 col-lg-2  pt-2">
                                    <input type="button" className='default-button-red-block btn-block' value='Filtar' />
                                </div>
                            </div>                         */}
                            <StldRow>
                                <Flex>
                                    <StyledForm style={{ width: "100%" }}>
                                    {
                                        isLoading ?
                                        <StldRow>
                                            <div className="text-center">
                                                <div className="d-flex align-items-center">
                                                    <strong style={{ color: "#EE4B21" }}>Carregando...</strong>
                                                    <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                                </div>
                                            </div>
                                        </StldRow>
                                        :
                                        <StyledTablePmePrograma>
                                            <StyledTablePage>
                                                {
                                                    listaUsuariosData?.data?.length > 0 ?
                                                    (
                                                        <div className="table-scroll font-0-9x table-bordered table-container" style={{borderLeft: "none", borderRight: "none", borderBottom: "none"}}>
                                                            <table className="table table-width table-sm">
                                                                <thead>
                                                                    <tr className="table-legend-info">
                                                                        <th key="nomeUsuario">Profissional</th>
                                                                        <th key="HFIc">HFi</th>
                                                                        <th key="colocacao">Ranking</th>
                                                                        <th key="topfee">Top Fee</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        listaUsuariosData?.data
                                                                            ?.map(usuario => {
                                                                                const calibracaoTotal = calcularCalibracaoTotal(
                                                                                    usuario.idProfissional,
                                                                                    usuario.dataAdmissao,
                                                                                    usuario.percProfissional
                                                                                );
                                                                                
                                                                                const hfmu = calcularHFMu(listaUsuariosData.data)[usuario.idArea];
                                                                                const hfmg = calcularHFMg(listaUsuariosData.data, calibracaoTotal);
                                                                                const hfmic = calculaHFIc(usuario.calibracaoPercProfissionalFranquia, calibracaoTotal, usuario.horaFaturada);
                                                                
                                                                                return {
                                                                                    ...usuario,
                                                                                    hfmic,
                                                                                };
                                                                            })
                                                                            .sort((a, b) => b.horaFaturada - a.horaFaturada) // Ordena pelo maior HFIc
                                                                            .map((usuario, index) => {

                                                                            const maisDeTresAnos = temMaisDeTresAnos(usuario.dataAdmissao);
                                                                            const rowStyle = index < 3 ? { backgroundColor: '#d4edda' } : {};

                                                                            return (
                                                                                <tr key={`row-profissional-${usuario.idProfissional}`} style={{fontSize: '13px', ...rowStyle}}>
                                                                                    <td className="text-center">{ usuario.nome }</td>                                                                                    
                                                                                    <td className="text-center">{ usuario.horaFaturada.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                                    <td className="text-center">{ index + 1 }º</td>   
                                                                                    <td className="text-center">
                                                                                        {
                                                                                            maisDeTresAnos ? ('') : 
                                                                                            (<span className="badge bg-warning">Rookie</span>)
                                                                                        }
                                                                                    </td>
                                                                                </tr>
                                                                            )})
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : listaUsuariosData?.data && listaUsuariosData.data?.length === 0 ? (
                                                        <StldColumn xs="12" sm="12" md="12">
                                                            <div className="alert alert-warning" role="alert">
                                                                Atenção! Nenhum resultado encontrado!
                                                            </div>
                                                        </StldColumn>
                                                    ) : (
                                                        <StldColumn xs="12" sm="12" md="12">
                                                            <div className="alert alert-warning" role="alert">
                                                                Erro ao carregar os dados ou estrutura inesperada.
                                                            </div>
                                                        </StldColumn>
                                                    )
                                                }
                                            </StyledTablePage>
                                        </StyledTablePmePrograma>
                                    }
                                    </StyledForm>
                                </Flex>
                            </StldRow>
                        </div>
                    :
                        <div className="card">
                            <StldRow>
                                <Flex>
                                    <StyledForm style={{ width: "100%" }}>
                                        {isLoading ? 
                                            <StldRow>
                                                <div className="text-center">
                                                    <div className="d-flex align-items-center">
                                                        <strong style={{ color: "#EE4B21" }}>Carregando...</strong>
                                                        <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                                    </div>
                                                </div>
                                            </StldRow> 
                                        : 
                                            <StyledTablePmePrograma>
                                                    <StldRow>
                                                        <div className="text-center mb-2">
                                                            <div className="d-flex align-items-center">
                                                                Selecione um Programa para ver o resultado dos Participantes
                                                            </div>
                                                        </div>
                                                    </StldRow> 
                                                    <StyledTablePage>
                                                    {
                                                        listaProgramas?.data?.length > 0 ? 
                                                        (
                                                            <div className="table-scroll font-0-9x table-bordered table-container">
                                                                <table className="table table-width" style={{ width: "100%" }}>
                                                                    <thead>
                                                                        <tr className="table-legend-info">
                                                                            <th key="ac">Ações</th>
                                                                            <th key="nomePrograma">Nome do Programa</th>
                                                                            <th key="inicio_termino" colSpan={2}>Vigência</th>                                                                            
                                                                            <th key="contemplados">Contemplados</th>
                                                                            {/* <th key="status">Status</th> */}
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {listaProgramas.data.map((programa, index) => (
                                                                            <tr key={index}>
                                                                                <td className="text-center">{ getacoes(programa.idPrograma) }</td>
                                                                                <td className="text-center">{ programa.nomePrograma }</td>
                                                                                <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataInicio)) }</td>
                                                                                <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataFim)) }</td>
                                                                                <td className="text-center">{ programa.contagemProfissionais }</td>
                                                                                {/* <td className="text-center">                                                                                   
                                                                                    {
                                                                                        programa.status == 1 
                                                                                        ? <i className="fa fa-circle text-success" aria-hidden="true"></i>
                                                                                        : <i className="fa fa-circle text-danger" aria-hidden="true"></i>
                                                                                    }                                                                                    
                                                                                </td> */}
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        ) : listaProgramas?.data && listaProgramas.data.length === 0 ? (
                                                            <StldColumn xs="12" sm="12" md="12">
                                                                <div className="alert alert-warning" role="alert">
                                                                    Atenção! Nenhum resultado encontrado!
                                                                </div>
                                                            </StldColumn>
                                                        ) : (
                                                            <StldColumn xs="12" sm="12" md="12">
                                                                <div className="alert alert-warning" role="alert">
                                                                    Erro ao carregar os dados ou estrutura inesperada.
                                                                </div>
                                                            </StldColumn>
                                                        )
                                                    }
                                                </StyledTablePage>
                                            </StyledTablePmePrograma>
                                        }
                                    </StyledForm>
                                </Flex>
                            </StldRow>
                        </div>
                    }
                </StyledDefaultPage>
                </main>
        </section >
    );
};

export const TopFeeMakerResultPmePage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <TopFeeMakerResultPme />
                </>
            )}
        </>
    );
};